// extracted by mini-css-extract-plugin
module.exports = {"centeredContent":"styles_centeredContent__1MUUp","actionButtons":"styles_actionButtons__1XZVZ"};